import React, { useState, useEffect } from 'react';
import logoImg from '../images/V2_DVF_Logo_Transparent_web.png';
import './Nav.css';

export default function Nav({ onOverviewOpen, onWebAppsOpen }) {
  const [scrolled,    setScrolled]    = useState(false);
  const [showBackTop, setShowBackTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
      setShowBackTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
        <div className="nav__inner">
          {/* Logo -- clicking returns to top */}
          <button
            className="nav__logo-link"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Back to top"
          >
            <img src={logoImg} alt="DVF Logo" className="nav__logo" />
          </button>

          {/* Links */}
          <ul className="nav__links">
            <li><a href="#projects">Projects</a></li>
            <li>
              <button className="nav__webapps-btn" onClick={onWebAppsOpen}>
                Web Apps
              </button>
            </li>
            <li><a href="#skills">Skills</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#contact">Contact</a></li>
            <li>
              <a href="/Dmitriy_F_Resume.pdf" target="_blank"
                rel="noopener noreferrer" className="nav__resume-link">
                Resume
              </a>
            </li>
            <li>
              <button className="nav__overview-btn" onClick={onOverviewOpen}>
                Overview
              </button>
            </li>
          </ul>
        </div>
      </nav>

      {/* Back to top button -- appears after scrolling 400px */}
      {showBackTop && (
        <button
          className="nav__back-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Back to top"
          title="Back to top"
        >
          ↑
        </button>
      )}
    </>
  );
}